// export const medicaidProvidersCollection: Collection<
//   CollectionDataTypes,
//   'medicaidProviders'
// > = {
//   id: 'medicaidProviders',
//   name: 'Medicaid Insurers',
//   ref: firestoreQuery(
//     INSURANCE_PROVIDERS_REF,
//     where('hasMedicaidOption', '==', true),
//   ),
//   access: patientAccess,
//   defaultSort: 'name',

import { ConsentFormTemplate, PracticeConsentForm } from '../../types'
import { UserGroup } from '../../types/shared/db'
import { PracticeContractTemplate, Template, TemplateKey } from '../../types/templates'
import { getPracticeConsentFormsCollectionPath } from '../../utils'
import { templateKeyToCollection } from '../../utils/documents'
import { adminCollectionAccess, practiceCollectionAccess } from '../constants'
import { CONSENT_FORM_TEMPLATES, MIDWIVES, PRACTICE_CONTRACT_TEMPLATES } from '../names'
import { Collection } from '../types/collection'

const createTemplatesCollection = (
  id: TemplateKey,
  name: string,
  practiceId?: string,
  access: UserGroup[] = adminCollectionAccess,
): Collection<Template> => ({
  id: templateKeyToCollection[id],
  _type: 'firestoreCollection',
  name,
  refPath: practiceId
    ? `${MIDWIVES}/${practiceId}/${templateKeyToCollection[id]}`
    : templateKeyToCollection[id],
  access,
  defaultSort: 'name',
})

export const adminConsentFormsCollection: Collection<ConsentFormTemplate> = {
  id: templateKeyToCollection.consentForm,
  _type: 'firestoreCollection',
  name: 'Consent Forms',
  refPath: CONSENT_FORM_TEMPLATES,
  access: adminCollectionAccess,
}

export const copyableConsentFormsCollection: Collection<ConsentFormTemplate> = {
  ...adminConsentFormsCollection,
  filters: [['canBeCopiedToPractice', '==', true]],
}

export const getPracticeConsentFormsCollection = (
  practiceId: string,
): Collection<PracticeConsentForm> => ({
  id: templateKeyToCollection.consentForm,
  _type: 'firestoreCollection',
  name: 'Consent Forms',
  refPath: getPracticeConsentFormsCollectionPath(practiceId),
  access: practiceCollectionAccess,
  defaultSort: 'name',
})

export const getConsentFormsCollection = (practiceId: string | null) => {
  if (practiceId) return getPracticeConsentFormsCollection(practiceId)
  return adminConsentFormsCollection
}

export const assessmentTemplatesCollection = createTemplatesCollection(
  'assessments',
  'Assessment Templates',
)
export const authTemplatesCollection = createTemplatesCollection(
  'authorizations',
  'Authorization Templates',
)
export const authAppealsTemplatesCollection = createTemplatesCollection(
  'authAppeals',
  'Auth Appeals Templates',
)
export const authInstructionsTemplatesCollection = createTemplatesCollection(
  'authInstructions',
  'Auth Instructions Templates',
)
export const claimTemplatesCollection = createTemplatesCollection('claims', 'Claim Templates')
export const clinicalsTemplatesCollection = createTemplatesCollection(
  'clinicals',
  'Clinical Templates',
)
export const invoiceTemplatesCollection = createTemplatesCollection(
  'invoiceAndReceipt',
  'Invoice / Receipt Templates',
)

export const consentFormTemplatesCollection = createTemplatesCollection(
  'consentForm',
  'Consent Form Templates',
  undefined,
  practiceCollectionAccess,
)

// Practice contract templates are HB-global only (authored by HB super-admins).
// Registry-friendly Collection<Template> (mirrors consentFormTemplatesCollection).
export const practiceContractTemplatesCollection = createTemplatesCollection(
  'practiceContract',
  'Practice Contract Templates',
)

// Typed view collection used by the admin template manager (mirrors adminConsentFormsCollection).
export const adminPracticeContractsCollection: Collection<PracticeContractTemplate> = {
  id: templateKeyToCollection.practiceContract,
  _type: 'firestoreCollection',
  name: 'Practice Contracts',
  refPath: PRACTICE_CONTRACT_TEMPLATES,
  access: adminCollectionAccess,
  defaultSort: 'name',
}
